<template>
  <div style="padding-bottom: 10px">
    <div class="row">
      <div class="col-md-2">
        <p>
          Реализации <i v-on:click="hide" class="tim-icons icon-minimal-up"></i>
        </p>
      </div>
      <div class="col-md-10">
        <p>
          Добавить новую
          <i v-on:click="newCall" class="tim-icons icon-chat-33"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" :a-page="false" :hide-pages="true" :page-limits="pageLimits" :tuning="false"
             :new-one="newOne"
             :default-sort="'initialDate'" :default-sort-direction="false"
             @update_top="updateTop"
             @resetNew="newOne = null"></big-one>
  </div>
</template>
<script>

import {
  BaseInput,
  Card
} from "@/components/index";

const initialDate = {header: "Дата ввода", name: "initialDate", sort:true, direction: true, show: true};
const executingDate = {header: "Дата установки", name: "executingDate", sort:true, direction: true, show: true};

export default{
  components:{
    Card,
    BaseInput
  },
  props:{
    item: {}
  },
  data() {
    return {
      content: [initialDate, executingDate],
      type: "kit",
      pageLimits: {tsr: this.item.id},
      newOne: null
    };
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    newCall() {
      let object = {tsr: this.item, id: 0};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    },
    updateTop() {
      this.$emit('update_top')
    }
  }
}
</script>
<style>
</style>
